import React from 'react';
import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import BrushIcon from '@mui/icons-material/Brush';
import DevicesIcon from '@mui/icons-material/Devices';
import SpeedIcon from '@mui/icons-material/Speed';
import PaletteIcon from '@mui/icons-material/Palette';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import './UIUXServices.css';

const services = [
  {
    icon: <BrushIcon sx={{ fontSize: 40 }} />,
    title: 'UI Design',
    description: 'Create visually stunning and intuitive user interfaces that align with your brand identity and user expectations.'
  },
  {
    icon: <DevicesIcon sx={{ fontSize: 40 }} />,
    title: 'Responsive Design',
    description: 'Ensure your digital products look and function perfectly across all devices and screen sizes.'
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: 'UX Research',
    description: 'Conduct thorough user research, create personas, and map user journeys to inform design decisions.'
  },
  {
    icon: <PaletteIcon sx={{ fontSize: 40 }} />,
    title: 'Design Systems',
    description: 'Develop comprehensive design systems and style guides for consistent brand experiences.'
  },
  {
    icon: <AutoFixHighIcon sx={{ fontSize: 40 }} />,
    title: 'Interactive Prototypes',
    description: 'Build interactive prototypes that simulate the real user experience for testing and stakeholder review.'
  },
  {
    icon: <AccessibilityNewIcon sx={{ fontSize: 40 }} />,
    title: 'Accessibility Design',
    description: 'Create inclusive designs that ensure your digital products are accessible to all users.'
  }
];

const UIUXServices = () => {
  return (
    <section className="services-overview">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" className="sd-section-title" gutterBottom>
            Our UI/UX Services
          </Typography>
          <Typography variant="subtitle1" className="sd-section-subtitle" gutterBottom>
            Comprehensive design solutions for exceptional digital experiences
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="services-grid">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="sd-service-card">
                  <CardContent>
                    <div className="sd-service-icon">
                      {service.icon}
                    </div>
                    <Typography variant="h6" className="sd-service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="sd-service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default UIUXServices; 